import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import PrimeVue from 'primevue/config'
import ReservationPreview from '@/components/reservation_preview.vue'
import ReservationDiff from '@/components/reservation_diff.vue'
import VueElementLoading from 'vue-element-loading'
import ReservationImport from '@/components/reservation_import.vue'

export default class extends Controller {
  static targets = ['fetchButton']
  connect() {
    const app = createApp(ReservationPreview, {
      creators: JSON.parse(this.element.dataset.creators),
      department: JSON.parse(this.element.dataset.department),
      cooperationSystemName: this.element.dataset.cooperationSystemName
    })
    app.use(PrimeVue, {
      locale: {
        accept: 'はい',
        reject: 'いいえ',
        choose: '選択',
        upload: 'アップロード',
        cancel: 'キャンセル',
        dayNames: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日'
        ],
        dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        today: '今日',
        clear: 'クリア',
        weekHeader: '週',
        firstDayOfWeek: 1,
        dateFormat: 'yy/mm/dd',
        weak: '弱い',
        medium: '普通',
        strong: '強い',
        passwordPrompt: 'パスワードを入力'
      }
    })
    app.component('ReservationDiff', ReservationDiff)
    app.component('ReservationImport', ReservationImport)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.fetchButtonTarget)
  }
}
